import { render, staticRenderFns } from "./ActivityWrapper.vue?vue&type=template&id=b5066322"
import script from "./ActivityWrapper.vue?vue&type=script&lang=js"
export * from "./ActivityWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports